// @flow

import React from 'react';
import type { Node } from 'react';
import PropTypes from 'prop-types';

// Helpers
import classNames from 'classnames';

// Components
import styles from 'components/SimpleModal.scss';

/**
 * Modal React component.
 * @return {JSX | null} - react component render.
 */
const SimpleModal: (props: Object) => Node | null = props => {
  const { extendStyle, isModalOpen, children, onClose } = props;
  const { classModal, classModalOpen, classModalContent } = styles;

  if (!isModalOpen) {
    if (typeof window !== 'undefined') {
      // $FlowFixMe
      document.body.style.overflow = 'visible';
    }

    return null;
  }

  if (typeof window !== 'undefined') {
    // $FlowFixMe
    document.body.style.overflow = 'hidden';
  }

  return (
    <div
      className={classNames(classModal, extendStyle, classModalOpen)}
      onClick={onClose}
      id="simpleModal"
    >
      <div className={classModalContent} onClick={stopPropagation}>
        {children}
      </div>
    </div>
  );
};

const stopPropagation = e => e.stopPropagation();

// $FlowFixMe
SimpleModal.propTypes = {
  isModalOpen: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.string
  ]),
  onClose: PropTypes.func.isRequired,
  extendStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
};

export default SimpleModal;



// WEBPACK FOOTER //
// ./src/Common/SimpleModal/index.js